import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

export const PermissionChecker = ({ children, permissions = [] }) => {
  const { allowedPermissions } = useAuth();

  if (permissions.length == 0) {
    return children;
  }
  if (allowedPermissions.some((ap) => permissions.includes(ap))) {
    return children;
  } else {
    return "You are not allowed to access this page!";
  }
};
